export function getSelectedRowDeleteTooltipKey({
  entityKind = "food",
  equivalenceCount = 0,
} = {}) {
  if (entityKind === "equivalent" || Number(equivalenceCount) > 0) {
    return "deleteEquivalent-string";
  }

  return "deleteFood-string";
}
